// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 28Wh6oQMGtkZtGs1aVzLHN
// Component: xTJEhzpCCql
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { NavigationBar } from "@plasmicpkgs/plasmic-nav"; // plasmic-import: jGx9tiKJoex/codeComponent
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_origin.module.css"; // plasmic-import: 28Wh6oQMGtkZtGs1aVzLHN/projectcss
import sty from "./PlasmicHomepageNavbar.module.css"; // plasmic-import: xTJEhzpCCql/css
import clipart773806PngQek3H4Ah from "./images/clipart773806Png.png"; // plasmic-import: -QEK3h4AH/picture

export const PlasmicHomepageNavbar__VariantProps = new Array("unnamedVariant");

export const PlasmicHomepageNavbar__ArgProps = new Array();

const __wrapUserFunction =
  globalThis.__PlasmicWrapUserFunction ?? ((loc, fn) => fn());

const __wrapUserPromise =
  globalThis.__PlasmicWrapUserPromise ??
  (async (loc, promise) => {
    return await promise;
  });

function PlasmicHomepageNavbar__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const [$queries, setDollarQueries] = React.useState({});
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "unnamedVariant",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.unnamedVariant
      }
    ],

    [$props, $ctx]
  );

  const $state = p.useDollarState(stateSpecs, { $props, $ctx, $queries });
  return true ? (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
    >
      <NavigationBar
        data-plasmic-name={"navigationBar"}
        data-plasmic-override={overrides.navigationBar}
        brand={
          <h1
            data-plasmic-name={"h1"}
            data-plasmic-override={overrides.h1}
            className={classNames(
              projectcss.all,
              projectcss.h1,
              projectcss.__wab_text,
              sty.h1
            )}
          >
            {"Bela Griva"}
          </h1>
        }
        className={classNames("__wab_instance", sty.navigationBar)}
        closeButton={
          <p.PlasmicImg
            alt={""}
            className={classNames(sty.img__g1Gt3)}
            displayHeight={"auto"}
            displayMaxHeight={"none"}
            displayMaxWidth={"none"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"auto"}
            src={"https://static1.plasmic.app/close.svg"}
          />
        }
        itemsGap={8}
        menuItems={
          <React.Fragment>
            <a
              className={classNames(
                projectcss.all,
                projectcss.a,
                projectcss.__wab_text,
                sty.link__m24Pa
              )}
              href={"/"}
            >
              {"Početna"}
            </a>
            <a
              className={classNames(
                projectcss.all,
                projectcss.a,
                projectcss.__wab_text,
                sty.link__gWeqQ,
                {
                  [sty.linkunnamedVariant__gWeqQdn7Vu]: hasVariant(
                    $state,
                    "unnamedVariant",
                    "unnamedVariant"
                  )
                }
              )}
              href={
                hasVariant($state, "unnamedVariant", "unnamedVariant")
                  ? `/about`
                  : `/about`
              }
            >
              {"O nama"}
            </a>
            <a
              className={classNames(
                projectcss.all,
                projectcss.a,
                projectcss.__wab_text,
                sty.link__ib00
              )}
              href={"tel:+381612439221"}
            >
              {"Kontakt"}
            </a>
            <a
              className={classNames(
                projectcss.all,
                projectcss.a,
                projectcss.__wab_text,
                sty.link___1VFv4
              )}
              href={`/galerija`}
            >
              {"Galerija"}
            </a>
          </React.Fragment>
        }
        openButton={
          <p.PlasmicImg
            alt={""}
            className={classNames(sty.img__vtY1W)}
            displayHeight={"auto"}
            displayMaxHeight={"none"}
            displayMaxWidth={"22px"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"100%"}
            src={{
              src: clipart773806PngQek3H4Ah,
              fullWidth: 1168,
              fullHeight: 1084,
              aspectRatio: undefined
            }}
          />
        }
        responsiveBreakpoint={768}
      />
    </div>
  ) : null;
}

const PlasmicDescendants = {
  root: ["root", "navigationBar", "h1"],
  navigationBar: ["navigationBar", "h1"],
  h1: ["h1"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicHomepageNavbar__ArgProps,
          internalVariantPropNames: PlasmicHomepageNavbar__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicHomepageNavbar__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicHomepageNavbar";
  } else {
    func.displayName = `PlasmicHomepageNavbar.${nodeName}`;
  }
  return func;
}

export const PlasmicHomepageNavbar = Object.assign(
  // Top-level PlasmicHomepageNavbar renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    navigationBar: makeNodeComponent("navigationBar"),
    h1: makeNodeComponent("h1"),
    // Metadata about props expected for PlasmicHomepageNavbar
    internalVariantProps: PlasmicHomepageNavbar__VariantProps,
    internalArgProps: PlasmicHomepageNavbar__ArgProps
  }
);

export default PlasmicHomepageNavbar;
/* prettier-ignore-end */
